export default __webpack_public_path__ + "static/media/cake_chocoicy.948bbd4c.jpg";